var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sign-page',{attrs:{"title-text":"执业医护人员统计","request":_vm.request,"column-list":_vm.columnList,"title-menus":[],"table-size":"large","tableActions":[]}})}
var staticRenderFns = []

export { render, staticRenderFns }